import { getFirestore, doc, setDoc } from 'firebase/firestore';
import { useManualSignUp } from './signGoogleController';
import { useLoginStore } from '../zustand/StoreAuth/store';
import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { FormData } from '../@types/types';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useTranslation } from 'react-i18next';

import Woman1 from "../assets/Img/M/woman1.png";
import Woman2 from "../assets/Img/M/woman2.png";
import Woman3 from "../assets/Img/M/woman3.png";

import Man1 from "../assets/Img/H/man1.png";
import Man2 from "../assets/Img/H/man2.png";
import Man3 from "../assets/Img/H/man3.png";

const db = getFirestore();

export function useQuizController() {
    const { signUpWithEmail } = useManualSignUp();
    const { userInfo } = useLoginStore();
    const navigate = useNavigate();
    const location = useLocation();
    const [loading, setLoading] = useState(false);

    const searchParams = new URLSearchParams(location.search);
    const gender = searchParams.get('gender');

    const [progress, setProgress] = useState(0);
    const [currentStep, setCurrentStep] = useState(1);
    const [formData, setFormData] = useState<FormData>({ gender: gender || '' });
    const [errors, setErrors] = useState<FormData>({});

    const [selectedBodyType, setSelectedBodyType] = useState('');
    const [bodyGoal, setBodyGoal] = useState('');
    const [age, setAge] = useState('');
    const [goal, setGoal] = useState('');
    const [motivation, setMotivation] = useState('');
    const [selectedGoals, setSelectedGoals] = useState<string[]>([]);
    const [target, setTarget] = useState('');
    const [lastWeight, setLastWeight] = useState('');
    const [conditioning, setConditioning] = useState('');
    const [pushUps, setPushUps] = useState('');
    const [lifestyle, setLifestyle] = useState('');
    const [youWalk, setYouWalk] = useState('');
    const [meals, setMeals] = useState('');
    const [sleeps, setSleeps] = useState('');
    const [water, setWater] = useState('');
    const [training, setTraining] = useState('');
    const [occasion, setOccasion] = useState('');
    const [height, setHeight] = useState('');
    const [weight, setWeight] = useState('');
    const [weightGoal, setWeightGoal] = useState('');
    const [imc, setImc] = useState<string>('');
    const { t } = useTranslation();
    const [email, setEmail] = useState<string>('');
    const [password, setPassword] = useState<string>('12345678');
    const [name, setName] = useState<string>('');

    const totalSteps = 23;

    const data = [
        t('useQuizController_data_strength'),
        t('useQuizController_data_weightLoss'),
        t('useQuizController_data_bodySculpting'),
        t('useQuizController_data_muscleGain'),
        t('useQuizController_data_agility'),
        t('useQuizController_data_cardiovascularHealth'),
        t('useQuizController_data_overallFitness'),
        t('useQuizController_data_fatBurning'),
        t('useQuizController_data_endurance'),
        t('useQuizController_data_energyBoost'),
        t('useQuizController_data_consistency'),
        t('useQuizController_data_libidoEnhancement'),
        t('useQuizController_data_mobility'),
        t('useQuizController_data_flexibility'),
        t('useQuizController_data_recovery'),
        t('useQuizController_data_improvePhysicalAppearance')
    ];

    const calculateIMC = () => {
        const heightInMeters = parseFloat(height.replace(',', '.')) / 100;
        const weightInKg = parseFloat(weight.replace(',', '.'));
        console.log(heightInMeters)

        if (heightInMeters && weightInKg) {
            const imcValue = (weightInKg / (heightInMeters * heightInMeters)).toFixed(2);
            setImc(imcValue);
        }
    };

    const getIMCMessage = (imcValue: any) => {

        if (imcValue < 18.5) {
            return t('useQuizController_imc_message_underweight');
        } else if (imcValue >= 18.5 && imcValue < 24.9) {
            return t('useQuizController_imc_message_normal_weight');
        } else {
            return t('useQuizController_imc_message_overweight');
        }
    };

    const getIMCImage = (imcValue: number) => {
        if (imcValue < 18.5) {
            return gender === 'homem' ? Man1 : Woman1;
        } else if (imcValue >= 18.5 && imcValue < 24.9) {
            return gender === 'homem' ? Man2 : Woman2;
        } else {
            return gender === 'homem' ? Man3 : Woman3;
        }
    };

    // Função para determinar o status do IMC
    const getIMCStatus = (imcValue: any) => {
        if (imcValue < 18.5) {
            return 'baixo';
        } else if (imcValue >= 18.5 && imcValue < 25) {
            return 'normal';
        } else {
            return 'alto';
        }
    };

    const status = getIMCStatus(parseFloat(imc));

    const validateStep = () => {
        let valid = true;
        const newErrors: FormData = {};

        switch (currentStep) {
            case 1:
                if (!formData.gender) {
                    newErrors.gender = t('useQuizController_step_1_gender');
                    valid = false;
                    toast.error(t('useQuizController_step_1_gender'));
                }
                break;
            case 2:
                // Caso 2 não possui validações específicas
                break;
            case 3:
                if (!selectedBodyType) {
                    newErrors.selectedBodyType = t('useQuizController_step_3_bodyType');
                    valid = false;
                    toast.error(t('useQuizController_step_3_bodyType'));
                }
                break;
            case 4:
                if (!bodyGoal) {
                    newErrors.bodyGoal = t('useQuizController_step_4_bodyGoal');
                    valid = false;
                    toast.error(t('useQuizController_step_4_bodyGoal'));
                }
                break;
            case 5:
                if (!motivation) {
                    newErrors.motivation = t('useQuizController_step_5_motivation');
                    valid = false;
                    toast.error(t('useQuizController_step_5_motivation'));
                }
                break;
            case 6:
                if (!target) {
                    newErrors.target = t('useQuizController_step_6_target');
                    valid = false;
                    toast.error(t('useQuizController_step_6_target'));
                }
                break;
            case 7:
                if (!lastWeight) {
                    newErrors.lastWeight = t('useQuizController_step_7_lastWeight');
                    valid = false;
                    toast.error(t('useQuizController_step_7_lastWeight'));
                }
                break;
            case 8:
                if (!conditioning) {
                    newErrors.conditioning = t('useQuizController_step_8_conditioning');
                    valid = false;
                    toast.error(t('useQuizController_step_8_conditioning'));
                }
                break;
            case 9:
                if (selectedGoals.length === 0) {
                    newErrors.selectedGoals = [t('useQuizController_step_9_selectedGoals')];
                    valid = false;
                    toast.error(t('useQuizController_step_9_selectedGoals'));
                }
                break;
            case 10:
                if (!pushUps) {
                    newErrors.pushUps = t('useQuizController_step_10_pushUps');
                    valid = false;
                    toast.error(t('useQuizController_step_10_pushUps'));
                }
                break;
            case 11:
                if (!lifestyle) {
                    newErrors.lifestyle = t('useQuizController_step_11_lifestyle');
                    valid = false;
                    toast.error(t('useQuizController_step_11_lifestyle'));
                }
                break;
            case 12:
                if (!youWalk) {
                    newErrors.youWalk = t('useQuizController_step_12_youWalk');
                    valid = false;
                    toast.error(t('useQuizController_step_12_youWalk'));
                }
                break;
            case 13:
                if (!meals) {
                    newErrors.meals = t('useQuizController_step_13_meals');
                    valid = false;
                    toast.error(t('useQuizController_step_13_meals'));
                }
                break;
            case 14:
                if (!sleeps) {
                    newErrors.sleeps = t('useQuizController_step_14_sleeps');
                    valid = false;
                    toast.error(t('useQuizController_step_14_sleeps'));
                }
                break;
            case 15:
                if (!water) {
                    newErrors.water = t('useQuizController_step_15_water');
                    valid = false;
                    toast.error(t('useQuizController_step_15_water'));
                }
                break;
            case 16:
                if (!training) {
                    newErrors.training = t('useQuizController_step_16_training');
                    valid = false;
                    toast.error(t('useQuizController_step_16_training'));
                }
                break;
            case 17:
                if (!occasion) {
                    newErrors.occasion = t('useQuizController_step_17_occasion');
                    valid = false;
                    toast.error(t('useQuizController_step_17_occasion'));
                }
                break;
            case 18:
                if (!height) {
                    newErrors.height = t('useQuizController_step_18_height');
                    valid = false;
                    toast.error(t('useQuizController_step_18_height'));
                }
                break;
            case 19:
                if (!weight) {
                    newErrors.weight = t('useQuizController_step_19_weight');
                    valid = false;
                    toast.error(t('useQuizController_step_19_weight'));
                }
                break;
            case 20:
                if (!weightGoal) {
                    newErrors.weightGoal = t('useQuizController_step_20_weightGoal');
                    valid = false;
                    toast.error(t('useQuizController_step_20_weightGoal'));
                }
                break;
            case 23:
                if (!name) {
                    newErrors.weightGoal = t('useQuizController_step_23_name');
                    valid = false;
                    toast.error(t('useQuizController_step_23_name'));
                }
                break;
            default:
                break;
        }

        setErrors(newErrors);

        return valid;
    };

    const handleNextStep = (callback: any) => {

        if (!validateStep()) {
            return;
        }

        callback();
        const newStep = currentStep + 1;
        setCurrentStep(newStep);
        setProgress((newStep / totalSteps) * 100);

        setFormData({
            ...formData,
            goal: goal,
            bodyGoal: bodyGoal,
            age: age,
            selectedBodyType: selectedBodyType,
            motivation: motivation,
            selectedGoals: selectedGoals,
            target: target,
            lastWeight: lastWeight,
            conditioning: conditioning,
            pushUps: pushUps,
            lifestyle: lifestyle,
            youWalk: youWalk,
            meals: meals,
            sleeps: sleeps,
            water: water,
            training: training,
            occasion: occasion,
            height: height,
            weight: weight,
            weightGoal: weightGoal,
            imc: imc
        });

        console.log("FORM=>", formData);
    };

    const handleContinue = () => {
        if (currentStep === 19 || currentStep === 20) {
            calculateIMC();
        }
        handleNextStep(() => { });
    };

    const toggleGoalSelection = (goal: string) => {
        setSelectedGoals(prevGoals =>
            prevGoals.includes(goal)
                ? prevGoals.filter(item => item !== goal)
                : [...prevGoals, goal]
        );
    };

    // Função para salvar os dados do usuário no Firebase após o login
    const saveUserData = async () => {
        try {
            setLoading(true);

            if (userInfo) {
                // Crie uma referência para o documento do usuário no Firestore
                const userDocRef = doc(db, 'users', userInfo.id);

                // Crie um novo documento de usuário com os campos necessários
                await setDoc(userDocRef, {
                    ...userInfo,
                    uid: userInfo?.id,
                    email: userInfo.email,
                    displayName: userInfo?.name,
                    createdAt: new Date(),
                    gender: formData.gender || "",
                    height: parseFloat(height.replace(',', '.')) / 100 || 0,
                    weight: parseFloat(weight) || 0,
                    goal: parseFloat(weightGoal) || 0,
                    imc: parseFloat(imc) || 0,
                    name: userInfo.name,
                    photo_url: userInfo.photo_url,
                    token: userInfo.token
                });
                console.log('Novo usuário criado no Firestore');

            }
        } catch (error) {
            console.error('Erro ao salvar dados do usuário:', error);
            toast.error(t('toast_error_save_user_data'));
        } finally {
            setLoading(false);
        }
    };

    const handleFunctions = async () => {
        if (!email) {
            toast.error(t('toast_error_enter_email'));
            return;
        }

        await signUpWithEmail(email, password, name);

        if (userInfo) {
            await saveUserData();
        } else {
            toast.error('Erro ao salvar');
        }
    };

    useEffect(() => {
        if (userInfo) {
            saveUserData().then(() => {
                navigate('/promotion');
            });
        }
    }, [userInfo, navigate]);

    return {
        handleFunctions,
        data,
        email,
        setEmail,
        name,
        setName,
        loading,
        errors,
        status,
        userInfo,
        navigate,
        progress,
        currentStep,
        formData,
        selectedBodyType,
        setSelectedBodyType,
        bodyGoal,
        setBodyGoal,
        age,
        setAge,
        goal,
        setGoal,
        motivation,
        setMotivation,
        selectedGoals,
        setSelectedGoals,
        target,
        setTarget,
        lastWeight,
        setLastWeight,
        conditioning,
        setConditioning,
        pushUps,
        setPushUps,
        lifestyle,
        setLifestyle,
        youWalk,
        setYouWalk,
        meals,
        setMeals,
        sleeps,
        setSleeps,
        water,
        setWater,
        training,
        setTraining,
        occasion,
        setOccasion,
        height,
        setHeight,
        weight,
        setWeight,
        weightGoal,
        setWeightGoal,
        imc,
        setImc,
        totalSteps,
        calculateIMC,
        getIMCMessage,
        getIMCStatus,
        handleNextStep,
        handleContinue,
        toggleGoalSelection,
        gender,
        getIMCImage
    };
}
